import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f97be09&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97be09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f97be09')) {
      api.createRecord('7f97be09', component.options)
    } else {
      api.reload('7f97be09', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f97be09&scoped=true", function () {
      api.rerender('7f97be09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSetting/wxAccount/index.vue"
export default component.exports